import React from "react";
import { Select } from "antd";
import useFetch from "../../hooks/useFetch";
const { Option } = Select;

export default function SelectInputAsync({
  label,
  required = false,
  placeholder = "",
  style = false,
  onChange,
  value,
  disabled = false,
  api_url,
  rebuildArray,
  mode = "normal",
  extra_label,
}) {
  const { loading, error, value: res_data } = useFetch(api_url);
  const options = loading || error ? [] : rebuildArray(res_data);
  return (
    <>
      {label && (
        <div className="d-flex justify-content-between align-items-center">
          <label
            className={`editLabelForm text-bold my-1 ${
              error ? "text-danger" : ""
            }`}
          >
            {label} {required && <span className="orange_color">*</span>}
          </label>
          <div>{extra_label}</div>
        </div>
      )}
      <Select
        showSearch
        mode={mode}
        className={error ? "error_border" : ""}
        style={style || { width: "100%" }}
        placeholder={placeholder || "Choose"}
        optionFilterProp="children"
        onChange={onChange}
        value={value}
        size="default"
        disabled={disabled}
        dropdownMatchSelectWidth={false}
      >
        {options
          ? [...options].map((item, index) => (
              <Option key={index} value={item.value} {...item}>
                {item.preview || item.label}
              </Option>
            ))
          : []}
      </Select>
      {error && <div className="text-danger">{JSON.stringify(error)}</div>}
    </>
  );
}
